import { SET_SUPPLIERS, SET_SUPPLIERS_DATA_LOADING, SET_SEARCH_SUPPLIER_BY_ID } from '../actions/types';

const initialState = {
  isLoading: false,
  suppliersData: [],
  searchByIdSupplierData: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_SUPPLIERS_DATA_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    case SET_SUPPLIERS:
      return {
        ...state,
        suppliersData: payload,
        isLoading: false,
      };
    case SET_SEARCH_SUPPLIER_BY_ID:
      return {
        ...state,
        searchByIdSupplierData: payload,
        isLoading: false,
      };
    default:
      return state;
  }
}
